export default {
    language: 'fr',

    providers: [],

    url: `${document.location.protocol}//${document.location.hostname}`,

    version: '0.0.1',
};
